//useUserRole hook contains specific logic for determining
//user roles by reading from Redux state
//dev config, and the database.

import { useAppSelector } from '../redux/hooks';

/**
 * Hook to determine user's effective role
 * Uses currentUser state (never cleared)
 */
export const useUserRole = () => {
    const { user } = useAppSelector((state) => state.currentUser);

    // Use role from current user
    const role = user?.role || 'User';
    const isSuperUser = role === 'SuperUser';
    const isHROrManager = role === 'Supervisor' || role === 'Administrator' || isSuperUser;

    return {
        role,
        isSuperUser,
        isHROrManager,
        isLoading: !user,
    };
};